export default "__VITE_ASSET__709153c2__"